import React from "react";
import "../../global.css";

const PHONE_DISPLAY = "+91 7631110005";
const PHONE_TEL = "+917631110005";
const WHATSAPP_URL = "https://wa.me/917631110005";

function FloatingContactButtons() {
  return (
    <div className="vsFloatContact" aria-label="Quick contact">
      <a
        href={`tel:${PHONE_TEL}`}
        className="vsFloatBtn vsFloatCall"
        title={`Call ${PHONE_DISPLAY}`}
        aria-label={`Call ${PHONE_DISPLAY}`}
      >
        <span className="vsFloatRing" aria-hidden="true" />
        <span className="vsFloatRing vsFloatRingDelay" aria-hidden="true" />
        <i className="fas fa-phone-alt" aria-hidden="true" />
      </a>

      <a
        href={WHATSAPP_URL}
        className="vsFloatBtn vsFloatWhatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat on WhatsApp"
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp" aria-hidden="true" />
      </a>
    </div>
  );
}

export default FloatingContactButtons;
